const PresetIcon = () => ` <svg width="100%" height="100%" viewBox="0 0 24 24" fill="currentColor">
  <path d="M20,2H4C2.9,2,2,2.9,2,4v16c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V4C22,2.9,21.1,2,20,2z M20,17H4L4,4h0h16V17z" />
</svg>`;
export default PresetIcon;
